/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
  "underscore",
  "backbone",
  "client/template",
  "client/views/list",
  "jquery",
  "i18n/i18n",
  "utils/jsonpath",
  "editors/attribute/js/attribute",
  "editors/content/js/content",
  "editors/values/js/values",
  "component!list",
  "component!mustache",
  "model/readonlytree"
  ],
  function(
    _,
    Backbone,
    Template,
    ListView,
    $,
    i18n,
    JSONPath,
    AttributeEditor,
    ContentEditor,
    ValueEditors,
    ListTemplate,
    MustacheTemplate,
    ReadOnlyTreeModel
  ) {

  // base function that mimics a template for use in AttributeEditor

  var AttributeCollection = Backbone.Collection.extend({

    initialize: function (models, options) {
      Backbone.Collection.prototype.initialize.apply(this, arguments);
      this.template = options.template;
      this.selectorPattern = options.selectorPattern;
      this.listenTo(this.template, "change", this.updateModels);
      this.updateModels();
    },

    updateModels: function () {
      var that = this,
          index = 0;

      _.each(this.template.schema.attributes, function (attribute, id) {
        var selectorPattern = that.selectorPattern || ".*";
        var selector = attribute.selector || "global";
        var selectorVisible = new RegExp(selectorPattern).test(selector);
        var dependencyOKAndVisible = selectorVisible && attribute.visible !== false && (!attribute.depends || that.evalExpr(attribute.depends, id));
    
        var visibleWithinSearchcontainer = that.isVisibleWithinSearchcontainer(attribute);
        if (dependencyOKAndVisible && visibleWithinSearchcontainer) {
          that.add({id: id, attribute: attribute}, {at: index});
          index++;
        } else {
          that.get(id) && that.get(id).trigger("destroy", that.get(id));
        }
      });
    },

    isVisibleWithinSearchcontainer: function (attribute) {
      return true;
    },

    getParentTemplate: function (template) {
      return template.parentTemplate;
    },

    evalExpr: function (expr, id) {
      var f = new Function("attributes", "return " + expr);
      return !!f.call(this, this.template.getAttributes());
    },
  });

  function AttributesStore(attributes, options) {
    var options = options || {};
    this.attributes = attributes;
    this.path = options.path || "";
    this.schema = options.schema;
    this.application = options.application;
    this.options = options;
    // this.legend = options.legend;
  }
  _.extend(AttributesStore.prototype, Backbone.Events, {
    hasAttribute: function (name) {
      return this.attributes[name] != null;
    },
    setAttribute: function (name, value)  {
      if (this.schema.attributes[name] && this.schema.attributes[name].format == "json") {
        try {
          value = JSON.parse(value);
        } catch (error) {
          value = { };
         }
      }
      this.attributes[name] = value;
    },
    removeAttribute: function (name) {
      delete this.attributes[name];
    },
    get: function(name) {
      if (this.schema.attributes[name] &&
          this.schema.attributes[name].format == "json") {
        return JSON.stringify(this.attributes[name], null, 1);
      }
      return this.attributes[name];
    },
    legend: function() {
      return this.options.legend;
    },
    getSchemaAttributeCollection: function (options) {
      if (this.schema) {
        return new AttributeCollection(null, { template: this, selectorPattern: options && options.selectorPattern });
      }
    },
  });

    
  var AttributesListView = ListView.extend({

      createEntryView: function (options) {
        var parentView = this.options.parentView,
            desc = options.model.get("attribute"),
            template = this.options.store,
            name = options.model.id,
            editor,
            registrationName = name;

        editor = new AttributeEditor({
          template: template,
          model: parentView.model,
          name: options.model.id,
          schema: desc
        })

        if (editor) {
          editor.render();
          this.listenTo(options.model, "destroy", function () {
            var editorIndex = _.indexOf(parentView.editors, editor);
            if (editorIndex) {
              parentView.editors.splice(editorIndex, 1);
            }
            editor.remove();
          });
          parentView.listenTo(editor, "change", parentView._editorChanged);
          parentView.editors.push(editor);
        }
        return editor;
      }
  });

  // A generic editor for templates
  // uses schema for creating fields
  var SchemaEditor = Backbone.View.extend({

    tagName: "div",

    initialize: function(options) {
      this.store  = options.store;
      this.el.className = "template";
      this.editors = [];
    },

    isEmpty: function() {
      return (!this.store.schema.attributes ||
              this.store.schema.attributes.length == 0);
    },

    storeEditingIsDisabled: function(contentEditor) {
      var schemaType = contentEditor.schema.type;
      return (schemaType === "mustache") && this.store.application.options.disableStoreEditing;
    },

    // add form and fields to this.el
    // can currently only be called once
    render: function () {
      if (!this.store || !this.store.schema) return this;

      var that = this,
          target = this.el;

      if (this.store.legend()) {
        target.appendChild(this.make("legend", {}, this.store.legend()));
      }

      var attributeCollection = this.store.getSchemaAttributeCollection({ selectorPattern: this.options.selectorPattern });

      this.attributesView = new AttributesListView({
        model: attributeCollection,
        store: this.store,
        template: this.stor,
        parentView: this
      });
      this.el.appendChild(this.attributesView.render().el);

      return this;
    },

    createPathBreadCrumb: function() {
      var el  = this.make("div", {"class": "breadcrumb"});
      var listTemplate = new ListTemplate(this.make("ul", {"class": "breadcrumb", "data-model": "path"}));
      var mustacheTemplate = new MustacheTemplate(
        this.make("script",
                  {"data-tag-name": "li"},
                  '<a href="#">{{{.}}}</a> <span class="divider">/</span>'));

      listTemplate.children = [{template: mustacheTemplate}];
      var model = new ReadOnlyTreeModel();
      var view = listTemplate.createView({model: model});
      model.load({path: this.store.path()});
      el.appendChild(view.el);
      return el;
    },

    _editorChanged: function(editor, value) {
      this.trigger("change", this, editor);
    },

    update: function() {
      var anyChanged = false;
      _.each(this.editors, function(editor) {
        anyChanged = editor.update() || anyChanged;
      });
      return anyChanged;
    },

    remove: function () {
      this.attributesView && this.attributesView.remove();
      Backbone.View.prototype.remove.apply(this, arguments);
    }
  });


  SchemaEditor.Store = AttributesStore;

  return SchemaEditor;
});
